// Performance Utilities
export const DevicePerformance = {
  isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768,
  isLowPower: navigator.hardwareConcurrency ? navigator.hardwareConcurrency <= 4 : false,
  prefersReducedMotion: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false,
  isLowMemory: navigator.deviceMemory ? navigator.deviceMemory < 4 : false,
  
  getIntensity(baseIntensity) {
    if (this.prefersReducedMotion) return 0;
    if (this.isLowMemory || this.isLowPower) return Math.floor(baseIntensity * 0.3);
    if (this.isMobile) return Math.floor(baseIntensity * 0.5);
    return baseIntensity;
  }
};

// Debounce Helper
export const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
};

// Throttle Helper
export const throttle = (fn, limit) => {
  let inThrottle;
  return (...args) => {
    if (!inThrottle) {
      fn(...args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

// Price Formatters
export const formatPrice = (price) => {
  if (typeof price !== 'number') return '0,00';
  return price.toFixed(2).replace('.', ',');
};

export const formatPriceParts = (price) => {
  const priceStr = price.toFixed(2);
  const parts = priceStr.split('.');
  return {
    intPart: parts[0] || '0',
    decPart: parts[1] || '00'
  };
};
